import { createAction } from '@reduxjs/toolkit';

export const SET_POSTS_PAGE_SORTING = 'SET_POSTS_PAGE_SORTING';
export const SET_SEARCH_PAGE_SORTING = 'SET_SEARCH_PAGE_SORTING';

export const setPostsPageSorting = createAction(SET_POSTS_PAGE_SORTING, (payload: string, meta) => {
  return { payload, meta };
});
export const setSearchPageSorting = createAction<string>(SET_SEARCH_PAGE_SORTING);
